
import axiosInterceptor from "../api/axiosInterceptor";
/* Metadata group manage */
export const metaDataGroupManage = async (bodyData) => {
    const url = "/api/admin/metadata/group/manage";
    try {
        // axiosInterceptor already returns response.data (see axiosInterceptor.js line 26)
        // So we don't need to access .data again
        const response = await axiosInterceptor.post(url, bodyData);
        console.log('📦 Service - Raw response from axiosInterceptor:', response);
        return response; // Already unwrapped by interceptor
    }
    catch (error) {
        console.error('📦 Service - Error:', error);
        throw error;
    }
};

export const checkFieldExistsInWorkflowMetadata = async (groupUuid, groupFieldName) => {
    const url = process.env.REACT_APP_BASE_API_URI ? 
        `${process.env.REACT_APP_BASE_API_URI}api/workflow/metadata/field/check` :
        `/api/workflow/metadata/field/check`;
    const bodyData = { groupId: groupUuid, fieldName: groupFieldName };
    try {
        const response = await axiosInterceptor.post(url, bodyData);
        return response;
    }
    catch (error) {
        console.error("Error checking field existence:", error);
        throw error;
    }
};